module.exports = "/_next/static/images/2-93ffbc10370c0d230ab5824504f1c3bf.jpg";